export enum FORM_ACTION {
  CREATE = "CREATE",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export type FormActionType = keyof typeof FORM_ACTION;
